import api from "../../services/api"
import leadDefaultHeader from "../../services/api_leadDefaultHeader"

const updateLead = data => {
  if (leadDefaultHeader()) {
    api.patch("/lead", data, leadDefaultHeader()).catch(() => {})
  }
}

export default updateLead
